import { render, staticRenderFns } from "./Alibaba-order-add.vue?vue&type=template&id=bdbe9130&scoped=true&"
import script from "./Alibaba-order-add.vue?vue&type=script&lang=js&"
export * from "./Alibaba-order-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbe9130",
  null
  
)

export default component.exports